import {
  confirmResetPassword,
  confirmSignIn,
  fetchUserAttributes,
  resetPassword,
  signIn,
  signOut as amplifySignOut,
  updateUserAttributes,
} from 'aws-amplify/auth';
import { Api } from '@/common/utils';

const isUnauthenticatedError = (error) =>
  error?.response?.status === 401 ||
  error?.code === 'NotAuthorizedException' ||
  error?.message === 'No current user';

export const getCurrentUser = async () => {
  try {
    const { data } = await Api.request({
      url: '/user/me',
    });

    return data;
  } catch (error) {
    if (isUnauthenticatedError(error)) {
      return null;
    }

    throw error;
  }
};

export const signInUser = (email, password) => signIn({ username: email, password });

export const completeNewPassword = (_user, password) =>
  confirmSignIn({ challengeResponse: password });

const updateAmplifyUserAttributes = async ({ firstName, lastName }) => {
  const attributes = await fetchUserAttributes().catch((error) => {
    if (isUnauthenticatedError(error)) {
      return null;
    }

    throw error;
  });

  if (!attributes) {
    return;
  }

  await updateUserAttributes({
    userAttributes: {
      given_name: firstName,
      family_name: lastName,
      name: `${firstName} ${lastName}`.trim(),
    },
  });
};

export const updateCurrentUser = async ({ firstName, lastName }) => {
  const [{ data }] = await Promise.all([
    Api.request({
      url: '/user/me',
      method: 'put',
      payload: {
        firstName,
        lastName,
      },
    }),
    updateAmplifyUserAttributes({ firstName, lastName }),
  ]);

  return data;
};

export const requestPasswordReset = (email) => resetPassword({ username: email });

export const confirmPasswordReset = (email, token, password) =>
  confirmResetPassword({
    username: email,
    confirmationCode: token,
    newPassword: password,
  });

export const signOut = async () => {
  try {
    await amplifySignOut();
  } catch (error) {
    console.log('error signing out: ', error);
  }

  return null;
};
